// extracted by mini-css-extract-plugin
export default {"BannerTextContainer":"BannerText_BannerTextContainer__q3BWf","Title":"BannerText_Title__qDYc7","Text":"BannerText_Text__qwrcb"};